import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './reducers'
import registerServiceWorker from './registerServiceWorker'
import Routing from './router'
import ThemeProvider, { globalTheme } from './theme'
import queryString from 'query-string'
import './loading.css'

const search = queryString.parse(window.location.search)
if ('auth' in search && 'order' in search && search.auth !== '' && search.order !== '') {
  localStorage.setItem('auth_token', search.auth)
  localStorage.setItem('order_id', search.order)
}
if ('referer' in search && search.referer !== '') {
  localStorage.setItem('redirect_to', search.referer)
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ThemeProvider theme={globalTheme}>
        <Routing />
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js